/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source SVG file at
 * `src/shared/joykit/packages/core/icons/svgs/<SIZE>/calendar.svg`, and run `yarn icon:codegen` to regenerate this file.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Calendar',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.764 3a.6.6 0 0 0-1.2 0v1.15H5a2.6 2.6 0 0 0-2.6 2.6v12a2.6 2.6 0 0 0 2.6 2.6h14a2.6 2.6 0 0 0 2.6-2.6v-12a2.6 2.6 0 0 0-2.6-2.6h-1.645V3.12a.6.6 0 1 0-1.2 0V4.15h-8.39V3zm-1.2 2.35v.428a.6.6 0 0 0 1.2 0V5.35h8.392v.55a.6.6 0 1 0 1.2 0v-.55H19a1.4 1.4 0 0 1 1.4 1.4v2.913H3.6V6.75A1.4 1.4 0 0 1 5 5.35h1.564zM3.6 10.863v7.887a1.4 1.4 0 0 0 1.4 1.4h14a1.4 1.4 0 0 0 1.4-1.4v-7.887H3.6z"
            fill="currentColor"
          />
        </>
      )
    },
    '32': {
      viewBox: '0 0 32 32',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.9406 4.16665C22.9406 3.83528 22.6719 3.56665 22.3406 3.56665C22.0092 3.56665 21.7406 3.83528 21.7406 4.16665V5.9H10.1524V4.16667C10.1524 3.8353 9.88379 3.56667 9.55242 3.56667C9.22105 3.56667 8.95242 3.8353 8.95242 4.16667V5.9H6.66657C4.86244 5.9 3.3999 7.36254 3.3999 9.16667V25.1667C3.3999 26.9708 4.86244 28.4333 6.66657 28.4333H25.3332C27.1374 28.4333 28.5999 26.9708 28.5999 25.1667V9.16667C28.5999 7.36254 27.1374 5.9 25.3332 5.9H22.9406V4.16665ZM21.7406 7.1V7.87054C21.7406 8.20191 22.0092 8.47054 22.3406 8.47054C22.6719 8.47054 22.9406 8.20191 22.9406 7.87054V7.1H25.3332C26.4746 7.1 27.3999 8.02528 27.3999 9.16667V13.2508H4.5999V9.16667C4.5999 8.02528 5.52518 7.1 6.66657 7.1H8.95242V7.87054C8.95242 8.20191 9.22105 8.47054 9.55242 8.47054C9.88379 8.47054 10.1524 8.20191 10.1524 7.87054V7.1H21.7406ZM4.5999 14.4508V25.1667C4.5999 26.3081 5.52518 27.2333 6.66657 27.2333H25.3332C26.4746 27.2333 27.3999 26.3081 27.3999 25.1667V14.4508H4.5999Z"
            fill="currentColor"
          />
        </>
      )
    }
  }
};

const icon = createSvgIcon(config);
export default icon;
